import { mapKeys } from 'lodash-es'

export const HTML_MANUAL = 'HTML_MANUAL'
export const HTML_AUTOMATIC = 'HTML_AUTOMATIC'

export const SCRAPING_TYPES = mapKeys(
  [
    { name: 'HTML Manual', value: HTML_MANUAL },
    { name: 'HTML Automatic', value: HTML_AUTOMATIC },
  ],
  'value',
)
